import type { LevelRun } from '../../core/level-runner';
import { t } from '../../i18n/es';

/**
 * The "SALTAR" prompt of the jump zone (GDD §11.1, §13.1, issue #94): a display-mono overlay that shows while the
 * pilot waits in the jump zone and goes away with the jump. It appears in 140 ms (0 ms with reduced motion, by the
 * global rule of the styles), never uses red and touches the DOM only when it changes.
 */
export function jumpPrompt(): { element: HTMLElement; update(run: LevelRun | null): void } {
  const element = document.createElement('div');
  element.className = 'jump-prompt display-mono';
  element.hidden = true;
  element.setAttribute('role', 'status');
  element.textContent = t('jump.prompt');
  return {
    element,
    update(run) {
      const visible = run !== null && run.core.levelState === 'SALTO' && run.jump === null;
      if (element.hidden === visible) element.hidden = !visible;
    },
  };
}
